<template>
  <suspense>
    <component :is="layout">
      <router-view></router-view>
    </component>
  </suspense>
</template>
<script>
import { ref, onMounted } from 'vue';
import useHead from '@/compositions/useHead';
import StoreLayout from '@/layouts/StoreLayout.vue';
import Favicons from '@/components/meta/Favicons.js';
import LocalStorage, { LocalStorageKeys } from '@/components/commons/LocalStorage';
import Tracking from '@/components/commons/Tracking';
import { useRouter } from 'vue-router';

export default {
  name: 'Article',

  components: {
    StoreLayout,
  },

  setup() {
    const pctScrolled = ref(0);

    const url = `${import.meta.env.VITE_STOREFRONT_BASE_URL}${useRouter().currentRoute.value.path}`;
   
    useHead({
      title: 'Modern, Mid Century & Scandinavian Furniture',
      meta: [
        {
          name: 'description',
          content: 'Shop article.com for high quality furniture at incredible prices for your Dining, Living and Bedroom.',
        },
      ],
      link: [
        ...Favicons,
        {
          rel: 'canonical',
          href: url,
        },
      ],
    });

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);

      window.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          Tracking.track('Page_View_Complete', {
            device: window.screen.width < 967 ? 'Mobile' : 'Desktop',
            start_time: LocalStorage.get(LocalStorageKeys.ON_VISIT_TIME),
            leave_time: Math.floor((Date.now() - LocalStorage.get(LocalStorageKeys.ON_VISIT_TIME)) / 1000),
            max_scroll_depth: pctScrolled.value,
          });
        } else if (document.visibilityState === 'visible') {
          Tracking.track('Page_View_Start', {
            device: window.screen.width < 967 ? 'Mobile' : 'Desktop',
            start_time: JSON.stringify(Date.now()),
          });
        }
      });

      function handleScroll() {
        const winheight = window.innerHeight || (document.documentElement || document.body).clientHeight;
        const docheight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
        const trackLength = docheight - winheight;
        pctScrolled.value = Math.max(pctScrolled.value || 0, Math.floor((scrollTop / trackLength) * 100));
      }
    });
  },

  computed: {
    layout() {
      return this.$route && this.$route.meta && this.$route.meta.layout ? this.$route.meta.layout : StoreLayout;
    },
  },
};
</script>
<style lang="postcss">
html {
  width: 100%;
}

.newsletter-container.container {
  max-width: none;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 350ms ease-in-out;
}
</style>
